import React, { Component } from 'react';
import PropTypes from 'prop-types';

const Empty = props =>
  <div className="cart">
    <p className="cart-empty">{App.t('cart.cart_empty')}</p>
  </div>;

export default Empty;
